// Module
var code = "<ul class=\"list-unstyled ng-tns-c0-0 ng-star-inserted\">\r\n    <ng-content select=\"ups-dashboard-accordeon-head-qv\"> </ng-content>\r\n</ul>\r\n\r\n";
// Exports
module.exports = code;